import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getConteudoChave, CONTEUDO_CHAVES } from '@/api/adminApi'
import { useRequireConteudoFlag } from '@/utils/featureFlags'
import styles from './VIPPage.module.css'

export function VIPPage() {
  const navigate = useNavigate()
  const { loading: featureLoading } = useRequireConteudoFlag(CONTEUDO_CHAVES.vip_enabled)
  const [linhas, setLinhas] = useState<string[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    getConteudoChave(CONTEUDO_CHAVES.vip_texto)
      .then((v) => {
        if (cancelled) return
        const text = (v ?? '').trim()
        setLinhas(text ? text.split(/\n/).map((s) => s.trim()).filter(Boolean) : [])
      })
      .catch(() => { if (!cancelled) setLinhas([]) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [])

  const vantagens = linhas.length > 0 ? linhas : ['Grupo exclusivo', 'Agendamento personalizado']

  if (featureLoading) return null

  return (
    <main className={`${styles.page} animate-slide-up`}>
      <button
        type="button"
        className={styles.backLink}
        onClick={() => navigate(-1)}
      >
        ← Voltar
      </button>

      <div className={styles.card}>
        <h1 className={styles.heading}>V.I.P</h1>
        {loading ? (
          <p style={{ color: 'var(--text-muted)' }}>A carregar…</p>
        ) : (
          <ul className={styles.vantagensList}>
            {vantagens.map((v, i) => (
              <li key={i} className={styles.vantagemItem}>
                {v}
              </li>
            ))}
          </ul>
        )}
        <button
          type="button"
          className={styles.btnSerVip}
          onClick={() => navigate('/cadastro')}
        >
          Ser um V.I.P
        </button>
      </div>
    </main>
  )
}
